
function getPageDebuggerParams() {
    if (window.FEGOEditor) return null;

    const { pageDebugger } = window.FEGORender.plugins || {};
    if (pageDebugger && pageDebugger.params) {
        return pageDebugger.params;
    }
    return null;
}

export { getPageDebuggerParams };
